/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { PRIMARY_BLUE, WHITE, BORDER_GREY } from 'constants/colours';

const CheckboxContainer = styled.div`
  width: ${({ width }) => width && `${width}px`};
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: ${({ marginBottom }) => `${marginBottom}px`};
  margin-top: ${({ marginTop }) => `${marginTop}px`};
`;

const StyledCheckbox = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: ${({ checkSize }) => `${checkSize}px`};
  max-width: ${({ checkSize }) => `${checkSize}px`};
  height: ${({ checkSize }) => `${checkSize}px`};
  margin-right: ${({ noText }) => !noText && '12px'};
  background-color: ${({ checked }) => {
    return checked ? PRIMARY_BLUE : WHITE;
  }};
  border: 1px solid;
  border-color: ${({ checked }) => {
    return checked ? PRIMARY_BLUE : BORDER_GREY;
  }};
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  text-align: left;
  &:hover {
    opacity: ${({ disabled }) => !disabled && 0.8};
  }
  opacity: ${({ disabled }) => disabled && 0.5};
  padding: 0;
`;

const CheckIcon = styled(FontAwesomeIcon)`
  font-size: 0.8rem;
  color: ${WHITE};
`;

const CheckboxText = styled.span`
  display: flex;
  flex: ${({ right }) => (right ? 0 : 1)};
  margin: auto;
  margin-right: ${({ right }) => (right ? '15px' : 'auto')};
  text-align: ${({ right }) => (right ? 'right' : 'left')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => disabled && `0.5`};
`;

const propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  checked: PropTypes.bool.isRequired,
  onSelectedItemChange: PropTypes.func,
  width: PropTypes.number,
  disabled: PropTypes.bool,
  right: PropTypes.bool,
  checkSize: PropTypes.number,
  noText: PropTypes.bool,
  marginBottom: PropTypes.number,
  marginTop: PropTypes.number
};

type CheckboxProps = PropTypes.InferProps<typeof propTypes>;

const Checkbox: React.FC<React.PropsWithChildren<CheckboxProps>> = ({
  text = '',
  checked,
  onSelectedItemChange = null,
  disabled = false,
  right = false,
  checkSize = 18,
  noText = false,
  width = null,
  marginBottom = 8,
  marginTop = null
}) => {
  const checkBox = (
    <StyledCheckbox
      data-test="checkbox-button"
      key="check"
      type="button"
      checkSize={checkSize}
      noText={noText}
      disabled={disabled}
      checked={checked}
    >
      {checked && <CheckIcon icon={faCheck} fixedWidth />}
    </StyledCheckbox>
  );

  const textBox = !noText && (
    <CheckboxText
      // Setting max-width for text when text is on right side and checkbox is on left
      // Adding 12 to checkboxSize to compensate for margin of checkbox
      className={`${right ? '' : `tw-max-w-[calc(100%_-_${`${checkSize + 12}px`})]`}`}
      key="text"
      right={right}
      disabled={disabled}
    >
      {text}
    </CheckboxText>
  );

  return (
    <CheckboxContainer
      data-test="checkbox"
      data-checked={checked}
      width={width}
      checkSize={checkSize}
      onClick={() => !disabled && !!onSelectedItemChange && onSelectedItemChange(!checked)}
      marginBottom={marginBottom}
      marginTop={marginTop}
    >
      {right ? [textBox, checkBox] : [checkBox, textBox]}
    </CheckboxContainer>
  );
};

export default Checkbox;
